module.exports = __webpack_public_path__ + "img/banner-en.d757889a.png";